import styled from 'styled-components'
import Ex1 from '../imagens/foto15obra.jpg'

export const Main = styled.main `

`
export const DivTitulo = styled.div `
text-align: center;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
background: rgba(0,0,0,1);
background-image: url(${Ex1});
background-position: right;
height: 45vh;
box-shadow: inset 0 0 0 200px rgba(0,0,0,0.5);
color: white;
gap: 40px;
h1 {
    font-size: 3rem;
}
h2 {
    font-size: 1.8rem;
}
@media (min-width: 201px) and (max-width: 500px) {
    h1 {
        font-size: 2.5rem;
    }

    h2 {
        font-size: 1.5rem;
    }
}
`
export const DivInfoPortfolio = styled.div `
background-color: #eaeaea;
display: flex;
justify-content: space-around;
`
export const DivInfo = styled.div `
text-align: center;
`
export const InfoDestacada = styled.p `
font-weight: 900;
font-size: 2.5rem;
`
export const InfoNaoDestacada = styled.p `
font-size: 1.1rem;
opacity: 0.7;
`
export const SectionProjetos = styled.section `
display: flex;
justify-content: space-around;
flex-wrap: wrap;
margin-bottom: 1rem;
`
export const DivTituloProjetos = styled.div `
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 10px;
margin-top: 1rem;
h2 {
    font-size: 2rem;
}
p {
    font-size: 1.4rem;
    text-align: center;
}
@media (min-width: 201px) and (max-width: 500px) {
    p {
        font-size: 1.3rem;
    }
}
`